import { useEffect, useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { Button } from "../../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";

const ESITI = { posti_disponibili: "Ha posti disponibili", nessun_posto: "Non ha posti", da_chiarire: "Risposta da chiarire" };

export default function WhatsAppConfermaDialog({ item, open, onOpenChange, onConfirm, onDiscard, onOpenChat, busy }) {
  const [posti, setPosti] = useState("");
  const [daQuando, setDaQuando] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!item) return;
    setPosti(item.posti == null ? (item.esito === "nessun_posto" ? "0" : "") : String(item.posti));
    setDaQuando(item.da_quando || "");
    setError("");
  }, [item]);

  if (!item) return null;
  const link = item.collegamenti || {};
  const struttura = link.struttura;

  const submit = () => {
    const value = Number(posti);
    if (posti === "" || !Number.isInteger(value) || value < 0) return setError("Inserisci un numero intero maggiore o uguale a zero.");
    setError("");
    onConfirm(item, value, daQuando.trim());
  };

  return <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-h-[90vh] max-w-xl overflow-y-auto">
      <DialogHeader>
        <DialogTitle>{struttura ? `Posti disponibili: ${struttura.nome}` : "Conferma disponibilità"}</DialogTitle>
        <DialogDescription>Controlla cosa ha risposto la struttura a mano. Solo se confermi, il numero di posti nella scheda viene aggiornato. Le risposte dai pulsanti SI / nessuna disponibilità sono già applicate in automatico.</DialogDescription>
      </DialogHeader>

      <div className="space-y-2 rounded border bg-slate-50 p-3 text-sm">
        <p><span className="text-slate-500">Struttura:</span> <strong>{struttura ? `${struttura.nome}${struttura.comune ? ` (${struttura.comune})` : ""}` : "—"}</strong></p>
        <p><span className="text-slate-500">Numero che ha risposto:</span> {item.numero || "—"}</p>
        {link.via_testo && <p className="text-xs text-slate-500">Come l'abbiamo riconosciuta: {link.via_testo}</p>}
        <p className="rounded bg-white p-2 italic">“{item.testo_originale || "Nessun testo"}”</p>
        <p><span className="text-slate-500">Cosa ha capito l'IA:</span> <strong>{ESITI[item.esito] || item.esito}{item.esito === "posti_disponibili" && item.posti != null ? ` (${item.posti})` : ""}</strong> · confidenza {Math.round((item.confidenza || 0) * 100)}%{item.certa ? "" : " · da verificare"}</p>
        {item.sintesi && <p className="text-xs text-slate-600">{item.sintesi}</p>}
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        <div className="space-y-1">
          <Label>Posti disponibili da salvare</Label>
          <Input type="number" min="0" value={posti} onChange={(event) => setPosti(event.target.value)} autoFocus />
          <p className="text-xs text-slate-500">Adesso in scheda: {struttura?.posti_attuali ?? "non indicato"}</p>
        </div>
        <div className="space-y-1">
          <Label>Da quando (facoltativo)</Label>
          <Input value={daQuando} onChange={(event) => setDaQuando(event.target.value)} placeholder="Es. dal 10 ottobre" />
        </div>
      </div>
      {error && <p className="text-sm text-rose-700">{error}</p>}

      <DialogFooter className="gap-2 sm:justify-between">
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => onDiscard(item)} disabled={busy}>Scarta la proposta</Button>
          <Button variant="ghost" onClick={() => onOpenChat(item)}>Apri conversazione</Button>
        </div>
        <div className="flex gap-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button onClick={submit} disabled={busy}>{busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Check className="mr-1 h-4 w-4" />}Conferma posti</Button>
        </div>
      </DialogFooter>
    </DialogContent>
  </Dialog>;
}
